<template>
    <div class="scc-faq-item-list" :class="[`scc-faq-item-list--${backgroundColor}`]">
        <FaqItem v-for="(faq, i) in faqs" :id="`${i}`" :key="i" :question="faq.question" :answer="faq.answer" />
    </div>
</template>

<script>
import './faq-item-list.scss';
import FaqItem from '../frequently-asked-questions/FaqItem';

const values = ['primary', 'secondary', 'white', 'grey'];

export default {
    name: 'FaqItemList',
    components: { FaqItem },
    __editor: {
        fields: {
            faqs: {
                widget: 'array',
                values: {
                    flat: false,
                    fields: {
                        question: {
                            widget: 'text',
                        },
                        answer: {
                            widget: 'textarea',
                        },
                    },
                },
            },
            backgroundColor: {
                widget: 'select',
                values: values,
            },
        },
    },
    props: {
        faqs: {
            type: Array,
            default: () => [],
        },
        backgroundColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return values.includes(val);
            },
        },
    },
};
</script>
